import gql from 'graphql-tag';

import ProductDataFragment from './ProductData.js';

export default gql`
  fragment ProductItemFragment on ProductItem {
    id
    type
    data {
      ...ProductDataFragment
    }
    ${ProductDataFragment}
  }
`;
